import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { initGA, trackPageView } from "../utils/ga";

const GoogleAnalytics = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search, i18n.language);
  }, [location, i18n.language]);

  return null;
};

export default GoogleAnalytics;
